
import { Path } from '@/main/router/routerPath';

import List from './List.vue';
import Edit from './Edit.vue';
import { NAME, CRUMB_LABEL_KEY } from './constants';

export const router = new Path(NAME, { Edit, List }, CRUMB_LABEL_KEY);
